import groupCallSelectPeoplePopup from './select-people-popup';
import stampit from 'stampit';

const componentName = 'groupCall';
const serviceName = 'GroupCallRealtimeComponent';
const moduleName = 'doxy.realtime.components.groupCall';

import './group-call.scss';
import { RootScopeEvents } from 'common/services/root-scope-types';

export { componentName, serviceName, moduleName };

export default angular
  .module(moduleName, [groupCallSelectPeoplePopup])
  .factory(
    'GroupCallRealtimeComponent',
    function (
      notificationFactory,
      VideoProviderFactory,
      groupCallService,
      groupCallSelectPeoplePopup,
      $rootScope
    ) {
      const MAX_PATIENTS_ON_CALL_COUNT = groupCallService.getMaxPatientsCount();

      return stampit({
        deepProps: {
          componentName,
          name: 'Group Call',
        },
        methods: {
          reset() {
            groupCallSelectPeoplePopup.hide();
          },

          open() {
            if (
              VideoProviderFactory.activeProvider.peopleCollection.length ===
              MAX_PATIENTS_ON_CALL_COUNT
            ) {
              $rootScope.$emit(RootScopeEvents.GROUP_CALL.MAX_REACHED);
              return notificationFactory.showCommon(
                'warning',
                'You have reached the maximum allowed for group calling'
              );
            }

            groupCallSelectPeoplePopup.open();
          },
        },
      });
    }
  ).name;
